import React, { useEffect, useState } from "react";
import { I18n } from "@aws-amplify/core";

import { fetchDataStoreKey } from "../../utils/datastore";

const QR_EVENT_TYPE = "QR_SCAN";
const QR_SCAN_KEY = "console.qr.scan";

const ScanComponent = ({ setScanError, handleScanDialog }) => {
  const [qrScanUrl, setQrScanUrl] = useState(null);

  useEffect(() => {
    const getQrScanUrl = async () => {
      try {
        const resp = await fetchDataStoreKey(QR_SCAN_KEY);

        if (resp) {
          console.log(`DS key '${QR_SCAN_KEY}', value: ${resp}`);
          setQrScanUrl(resp.url);
        } else {
          setScanError(I18n.get("qrScanNoUrl"));
        }
      } catch (err) {
        console.error("Failed to load QR scan URL:", err);
        setScanError(I18n.get("qrScanUrl"));
      }
    };

    getQrScanUrl();
  }, [setScanError]);

  useEffect(() => {
    const handleMessage = (event) => {
      if (!event.data) return;

      try {
        const { type, data } = event.data;

        if (type === QR_EVENT_TYPE && data) {
          const jsonScan = typeof data === "string" ? JSON.parse(data) : data;

          let id = null;

          if (jsonScan.pzi_id) {
            console.log("Found a PZI ID string");
            id = jsonScan.pzi_id;
          } else if (jsonScan.zone_id) {
            console.log("Found a Zone ID string");
            id = jsonScan.zone_id;
          }

          if (id && /^[0-9]{1,6}$/.test(id.toString())) {
            const xid = parseInt(id);
            console.log("Using PZI ID: " + xid);
            handleScanDialog(xid);
          } else {
            setScanError(I18n.get("qrScanFormat"));
          }
        }
      } catch (err) {
        console.error("Failed to decode QR code: ", err);
        setScanError(I18n.get("qrScanDecode"));
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [handleScanDialog, setScanError]);

  if (!qrScanUrl) {
    return <p>Loading scanner...</p>;
  }

  return (
    <iframe
      src={qrScanUrl}
      id="scannerIframe"
      allow="camera"
      title="QR Scanner"
      style={{
        width: "100%",
        height: "400px",
        border: "0px",
        overflow: "clip",
      }}
    />
  );
};

export default ScanComponent;
